import FullPageLoader from "@/components/Common/FullPageLoader";
import PermissionDenied from "@/components/Common/PermissionDenied";
import {useIsAdmin, useUserId} from "@/hooks/useUserHooks";
import {memo, type FC} from "react";
import {Outlet} from "react-router";

const RequireAdmin: FC = () => {
  const userId = useUserId();
  const isAdmin = useIsAdmin();

  if (!userId) {
    return <FullPageLoader />;
  }

  if (!isAdmin) {
    return <PermissionDenied />;
  }

  return <Outlet />;
};

export default memo(RequireAdmin);
